import ExcelJS from 'exceljs'

export const encodeToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    let result = ''
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = (e) => {
      result = e.target.result.split(',')[1]
      resolve(result)
    }
    reader.onerror = (e) => {
      reject(e)
    }
  })
}

const getCompleteFileType = (type) => {
  switch (type) {
    case 'pdf':
      return `application/${type}`
    case 'jpg':
    case 'jpeg':
    case 'png':
      return `image/${type}`
    case 'xls':
      return 'application/vnd.ms-excel'
    default:
      return `application/${type}`
  }
}

export const downloadFile = (data, fileExtension, fileName) => {
  const base64Data = data.split("'")[1]
  const link = document.createElement('a')
  link.target = '_blank'
  link.href = `data:${getCompleteFileType(fileExtension)};base64,${base64Data}`
  link.download = `${fileName}.${fileExtension}`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const getFormattedTime = () => {
  const today = new Date()
  const y = today.getFullYear()
  const m = today.getMonth() + 1
  const d = today.getDate()
  const h = today.getHours()
  const mi = today.getMinutes()
  const pad = (num) => num.toString().padStart(2, '0')
  return `${pad(d)}_${pad(m)}_${y}_${pad(h)}h${pad(mi)}m`
}

const getFormatedValue = (item, column, combos, intl) => {
  const value = item[column.field]
  if (value === null || value === undefined || value === '') {
    return ''
  }

  if (column.render) {
    return column.render(value, item)
  }

  let exportType = column.exportType
  if (column.exportType === 'date_iso' && typeof value === 'string' && value.includes('/')) {
    exportType = 'date'
  }

  switch (exportType) {
    case 'date_iso': {
      return intl.formatDate(new Date(value))
    }
    case 'date': {
      const dateParts = value.split('/')
      return intl.formatDate(new Date(dateParts[2], dateParts[1] - 1, dateParts[0]), {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    }
    case 'combo': {
      const comboOption =
        column.comboId &&
        combos[column.comboId] &&
        combos[column.comboId].data.find(({ key }) => String(key) === String(value))
      return comboOption ? comboOption.value : value
    }
    case 'currency': {
      const numberValue = parseFloat(value)
      if (isNaN(numberValue)) return value
      return numberValue.toFixed(2).replace('.', ',')
    }
    case 'boolean': {
      return value
        ? intl.formatMessage({ id: 'global.true' })
        : intl.formatMessage({ id: 'global.false' })
    }
    default: {
      return value
    }
  }
}

export const capitalizeStr = (str) => {
  if (typeof str !== 'string' || !str) return ''
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => {
      if (!word.length) return ''
      return word[0].toUpperCase() + word.substr(1)
    })
    .join(' ')
}

export const dataToXLS = async (data, columns, combos, intl, from, fileName) => {
  const exportableColumns = columns.filter((column) => column.export !== false)

  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('Datos')

  worksheet.columns = exportableColumns.map((column) => ({
    header: intl.formatMessage({
      id: `pages.${from || 'applications'}.table.columns.${column.field}.title`,
    }),
    key: column.field,
    width: 20,
  }))

  data.forEach((record) => {
    const rowData = {}
    exportableColumns.forEach((column) => {
      rowData[column.field] = getFormatedValue(record, column, combos, intl)
    })
    worksheet.addRow(rowData)
  })

  const headerRow = worksheet.getRow(1)
  headerRow.font = { name: 'Calibri', size: 12, bold: true }
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD3D3D3' },
    }
    cell.alignment = { vertical: 'middle', horizontal: 'center' }
  })

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${fileName}`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
